module.exports = "<!-- ko if: hasIcon -->\r\n<svg class=\"sv-svg-icon\" data-bind=\"css: css\" role=\"img\"><use></use></svg>\r\n<!-- /ko -->\r\n";